/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, useContext, useEffect, useState } from "react";
import Keycloak from "keycloak-js";

const AuthenticationContext = createContext({});

export default AuthenticationContext;

export const useAuthentication = () => {
  const context = useContext(AuthenticationContext);
  if (!context) {
    throw new Error(
      "useKeycloak must be used within an AuthenticationProvider",
    );
  }
  return context;
};

async function initKeycloak(config, initOptions, setKeycloak) {
  const client = new Keycloak(config);
  await client.init(initOptions);
  setKeycloak(client);
}

export function AuthenticationProvider({
  config,
  initOptions,
  onLoad,
  minExpiration,
  children,
  loadingComponent,
  ...props
}) {
  // eslint-disable-next-line no-unused-vars
  // const [token, setToken] = useState();
  const [session, setSession] = useState(null);
  useEffect(() => {
    initKeycloak(config, initOptions, setSession);
  }, []);
  useEffect(() => {
    const refreshTokenInterval = setInterval(
      () => {
        if (session && session.authenticated) {
          session
            .updateToken(minExpiration)
            .then((refreshed) => {
              if (refreshed) {
                console.debug("Token refreshed successfully");
              } else {
                console.warn("Token not refreshed, or session not active");
              }
            })
            .catch((error) => {
              console.error("Error refreshing token:", error);
            });
        }
      },
      (minExpiration - 10) * 100,
    );
    return () => clearInterval(refreshTokenInterval);
  }, [session]);
  return (
    <AuthenticationContext.Provider value={session}>
      {(!!session && session?.authenticated && children) || loadingComponent}
    </AuthenticationContext.Provider>
  );
}
